import translator from "../../../components/localization/translator";
import { USER_ROLES } from "../../../config/constants";

export const REVIEWER_ROLES = [
    USER_ROLES.MANAGER,
    USER_ROLES.ORDER_MANAGER,
    USER_ROLES.ADMIN,
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.PARTNER_MANAGER,
    USER_ROLES.ACCOUNTANT,
];

export const getPageUrl = (page) => {
    if (typeof page === "string") {
        return page;
    }
    if (!page) {
        return "";
    }
    return page.url || page.link || page.src || page.path || "";
};

export const getFileType = (page) => {
    return (typeof page === "object" && (page.mimeType || page.type || page.fileType)) || "";
};

export const getFileName = (page, index) => {
    const rawName = (typeof page === "object" && (page.originalName || page.name)) || "";
    if (rawName) {
        try {
            return decodeURIComponent(rawName);
        } catch (e) {
            return rawName;
        }
    }
    return `${translator.translate("_sanitary_book_")} ${index + 1}`;
};

export const isPdf = (page) => {
    const url = getPageUrl(page);
    const name = (typeof page === "object" && page.originalName) || "";
    if (String(getFileType(page)).toLowerCase().indexOf("pdf") !== -1) {
        return true;
    }
    if (/\.pdf(\?|$)/i.test(String(name))) {
        return true;
    }
    return /\.pdf(\?|$)/i.test(url);
};

export const isImage = (page) => {
    const url = getPageUrl(page);
    const name = (typeof page === "object" && page.originalName) || "";
    if (String(getFileType(page)).toLowerCase().indexOf("image") !== -1) {
        return true;
    }
    if (/\.(jpe?g|png|gif|bmp|webp|svg)(\?|$)/i.test(String(name))) {
        return true;
    }
    return /\.(jpe?g|png|gif|bmp|webp|svg)(\?|$)/i.test(url);
};

export const getPages = (book) => {
    let pages = book && (book.pages || book.images || book.files);
    if (!pages && book && book.fileUrl) {
        pages = [book.fileUrl];
    }
    if (!pages && book && book.file) {
        pages = [book.file];
    }
    if (!pages) {
        pages = [];
    }
    if (typeof pages === "string") {
        pages = [pages];
    }
    return Array.isArray(pages) ? pages : [];
};

export const getBooks = (data) => {
    const list = (data && data.sanitaryBooks) || data;
    if (Array.isArray(list)) {
        return list.filter(item => item && item._id);
    }
    return data ? [data] : [];
};
